/** Audit-only fields attached to success payloads; must not persist in domain reducers. */
const AUDIT_PAYLOAD_KEYS = [
  "__prevBranch",
  "__prevStoreHours",
  "__prevBranchesHours",
  "__prevServiceBaseline",
  "__prevCategory",
  "__prevItem",
  "__prevModifierGroup",
] as const;

export const stripAuditPayloadKeys = <T extends Record<string, unknown>>(
  payload: T
): T => {
  const result = { ...payload };
  for (const key of AUDIT_PAYLOAD_KEYS) {
    delete result[key];
  }
  return result;
};
